import { createAsyncThunk } from '@reduxjs/toolkit';
import { deleteSpaApi, deregisterSpaUserApi, editSpaApi, editSpaModelApi, flagSpaApi, getFieldHistoryApi, getFieldHistorySummaryApi, getSpaById, getUserSpas, registerSpaUserApi } from '../../services/api/spas.api';
import RootState from "../states/root.state";

export const fetchSpa = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'spa',
    async (id, {rejectWithValue, getState}) => {
        try {

            const {user} = getState();
            const token = user.accessToken;
    
            const response = await getSpaById(token, id);
            return response.data;
            
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching spa.");
            } else {
                return rejectWithValue('An error occurred while fetching spa.');
            }
        }
    }
);

export const editSpa = createAsyncThunk<any, {guid:string, nick_name?:any, dealership_id?:any, arctic_serial_number?:string}, { rejectValue: string; state: RootState}>(
    'spa/update',
    async (updateInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            const response = await editSpaApi(token,updateInfo);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while editing spa.");
            } else {
                return rejectWithValue('An error occurred while editing spa.');
            }
        }
    }
);

export const editSpaModel = createAsyncThunk<any, {guid:string, tub_model_id?:any}, { rejectValue: string; state: RootState}>(  
    'spa/update-model',
    async (updateInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            const response = await editSpaModelApi(token,updateInfo);
            return response.data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while editing spa model.");
            } else {
                return rejectWithValue('An error occurred while editing spa model.');
            }
        }
    }
);

export const deleteSpa = createAsyncThunk<any, {guid:string, params:string}, { rejectValue: string; state: RootState}>(
    'spa/delete',
    async (spaInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await deleteSpaApi(token, spaInfo.guid);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while deleting spa.");
            } else {
                return rejectWithValue('An error occurred while deleting spa.');
            }
        }
    } 

);

export const deregisterSpaUser = createAsyncThunk<any, {guid:string, user_id:string}, { rejectValue: string; state: RootState}>(
    'spa/deregister',
    async (spaInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await deregisterSpaUserApi(token, spaInfo);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while deregistering spa user.");
            } else {
                return rejectWithValue('An error occurred while deregistering spa user.');
            }
        }
    } 
);

export const registerSpaUser = createAsyncThunk<any, {guid:string, user_id:string}, { rejectValue: string; state: RootState}>(
    'spa/register-to-user',
    async (spaInfo, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await registerSpaUserApi(token, spaInfo);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while registering spa user.");
            } else {
                return rejectWithValue('An error occurred while registering spa user.');
            }
        }
    } 
);

export const flagSpa = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'spa/flag',
    async (guid, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;

            const response = await flagSpaApi(token, guid);
            return response.data;

        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while flagging spa.");
            } else {
                return rejectWithValue('An error occurred while flagging spa.');
            }
        }
    } 
);

export const fetchFieldHistory = createAsyncThunk<any, {guid:string, field_name?:string, page?:number}, { rejectValue: string; state: RootState}>(
    'spa/field-history',
    async (params, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            const {data} = await getFieldHistoryApi(token, params);
            return data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching field history.");
            } else {
                return rejectWithValue('An error occurred while fetching field history.');
            }
        }
    }
);

export const fetchFieldHistorySummary = createAsyncThunk<any, string, { rejectValue: string; state: RootState}>(
    'spa/field-history-summary',
    async (id, {rejectWithValue, getState}) => {
        try {
            const {user} = getState();
            const token = user.accessToken;
            const {data} = await getFieldHistorySummaryApi(token, id);
            return data;
        } catch (error: any) {
            if (error.response) {
                return rejectWithValue(error.response.data.data.message??error.response.data.message??"An error occurred while fetching field history summary.");
            } else {
                return rejectWithValue('An error occurred while fetching field history summary.');
            }
        }
    }
);